import { AdvisoriesEffects } from '../modules/advisories/advisories.effects'
import { AppointmentEffects } from '../modules/appointment/appointment.effects'
import { AuthEffects } from '../modules/auth/auth.effects'
import { ModeConfigurationEffects } from '../modules/auth/mode-configuration.effects'
import { ConfigEffects } from '../modules/config/config.effects'
import { CallsStatusesEffect } from '../modules/dashboard/calls-statuses/call-status.effects'
import { CallEffects } from '../modules/dashboard/calls.effects'
import { IssueEffects } from '../modules/issue/issue.effects'
import { AarEffects } from '../modules/location/aar/aar.effects'
import { ReviewEffects } from '../modules/location/aar/review/review.effects'
import { LocationEffects } from '../modules/location/location.effects'
import { NearbyLandmarkEffects } from '../modules/location/nearby-landmark.effects'
import { TowLocationEffects } from '../modules/location/tow-location/tow-location.effects'
import { MemberEffects } from '../modules/member/member.effects'
import { MemberQuickRenewEffects } from '../modules/member/member-quick-renew.effects'
import { QuotesEffects } from '../modules/quotes/quotes.effects'
import { RouteDistanceEffects } from '../modules/route-distance/route-distance.effects'
import { ServicingClubEffects } from '../modules/servicing-club/servicing-club.effects'
import { SessionEffects } from '../modules/session/session.effects'
import { SubmitEffects } from '../modules/submit/submit.effects'
import { TaggingEffects } from '../modules/tagging/tagging.effects'
import { TowServiceAvailabilityEffects } from '../modules/tow-service-availability/tow-service-availability.effects'
import { UIEffects } from '../modules/ui/ui.effects'
import { VehicleEffects } from '../modules/vehicle/vehicle.effects'
import { WizardEffects } from '../modules/wizard/wizard.effects'
import { SharedEffects } from '../shared/shared.effects'

/**
 * Array of all NgRx effects for the DRR library.
 *
 * When adding a new effect, add it here so consumers automatically get it
 * without needing to update their module imports.
 */
export const drrEffects = [
  AarEffects,
  AdvisoriesEffects,
  AppointmentEffects,
  AuthEffects,
  CallEffects,
  CallsStatusesEffect,
  ConfigEffects,
  IssueEffects,
  TowLocationEffects,
  LocationEffects,
  NearbyLandmarkEffects,
  MemberEffects,
  MemberQuickRenewEffects,
  ModeConfigurationEffects,
  QuotesEffects,
  ReviewEffects,
  RouteDistanceEffects,
  ServicingClubEffects,
  SessionEffects,
  SharedEffects,
  SubmitEffects,
  TaggingEffects,
  TowServiceAvailabilityEffects,
  UIEffects,
  VehicleEffects,
  WizardEffects,
]
